export const dataTable1 = {
  headers: [
    { title: "Security Name", tooltip: false },
    { title: "Ticker Symbol", tooltip: false },
    { title: "Quantity", tooltip: true },
    { title: "Price as of Last Market Close", tooltip: true },
    { title: "Average Cost per Unit", tooltip: true },
    { title: "Time Weighted Return since Inception", tooltip: true },
    { title: "Market Value as of Last Market Close", tooltip: true },
    { title: "% of Portfolio", tooltip: false },
  ],
  rows: [
    [
      { value: "PIMCO gis U.S Short-Term Fund Institutional Class(USD)(Offshore)" },
      { value: "G7112J507" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "$21,176,050.26" },
      { value: "2.34%" },
    ],
    [
      { value: "Lord Abbett Ultra Short Bond Fund Class Z (USD)(acc)",},
      { value: "G5648W349" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "$21,176,050.26" },
      { value: "2.34%" },
    ],
    [
      { value: "Apple Inc", tooltip: false },
      { value: "AAPL" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "$21,176,050.26" },
      { value: "2.34%" },
    ],
    [
      {
        value: "Ishares VII PLC - Ishares Usd Treasury Bond 1-3YR Ucits ETF Usd(acc) B Accum",
        tooltip: false,
      },
      { value: "IHVPF"},
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "$21,176,050.26" },
      { value: "2.34%" },
    ],
    [
      { value: "Amazon.Com Inc", tooltip: false },
      { value: "AMZN" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "$21,176,050.26" },
      { value: "2.34%" },
    ],
    [
      { value: "Total", tooltip: false, iconLink: false },
      { value: "" },
      { value: "" },
      { value: "" },
      { value: "" },
      { value: "-5.29%"},
      { value: "$21,176,050.26" },
      { value: "17.61%%" },
    ],
  ],

  totals: true,
  headerTag: false,
};


export const dataTable2 = {
  headers: [
    { title: "Asset Class", tooltip: false },
    { title: "Market Value as of Last Market Close", tooltip: true },
    { title: "Average Daily Balance since Inception", tooltip: true },
    { title: "Since Inception", tag: true },
    { title: "Trailing 12 Months", tag: true },
    { title: "Year to date", tag: true },
    { title: "% of Portfolio", },
  ],
  rows: [
    [
      { value: "Fixed Income" },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Equity",},
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Cash & Cash Equivalent", tooltip: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "-$10.94"},
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      {
        value: "Commodities",
        tooltip: false,
      },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Alternatives", tooltip: false, iconLink: true },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Total", tooltip: false, iconLink: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
  ],

  totals: true,
  headerTag: true,
};


export const dataTable3 = {
  headers: [
    { title: "Asset Type", tooltip: false },
    { title: "Market Value as of Last Market Close", tooltip: true },
    { title: "Average Daily Balance since Inception", tooltip: true },
    { title: "Since Inception", tag: true },
    { title: "Trailing 12 Months", tag: true },
    { title: "Year to date", tag: true },
    { title: "% of Portfolio", },
  ],
  rows: [
    [
      { value: "ETFs" },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Stocks",},
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Bonds", tooltip: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "-$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      {
        value: "Money Market Funds",
        tooltip: false,
      },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Cash", tooltip: false, iconLink: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "-$11.40"},
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "REITs", tooltip: false, iconLink: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Private Equity", tooltip: false, iconLink: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
    [
      { value: "Options", tooltip: false, iconLink: false },
      { value: "-$21,176,050.26"},
      { value: "-1,857,548.27" },
      { value: "-$11.40" },
      { value: "-$10.94" },
      { value: "-6.47%" },
      { value: "-2.34%"},
    ],
    [
      { value: "Total", tooltip: false, iconLink: false },
      { value: "$21,176,050.26" },
      { value: "1,857,548.27" },
      { value: "$11.40" },
      { value: "$10.94" },
      { value: "6.47%" },
      { value: "2.34%" },
    ],
  ],

  totals: true,
  headerTag: true,
};

export const dataTableCustodian = {
  headers: [
    { title: "Custodian", tag: false, tooltip: false },
    {
      title: "Market Value as of Last Market Close",
      tag: false,
      tooltip: true,
    },
    {
      title: "Average Daily Balance since Inception",
      tag: false,
      tooltip: true,
    },
    { title: "Since Inception", tag: true, tooltip: false },
    { title: "Trailing 12 Months", tag: true, tooltip: false },
    { title: "Year to Date", tag: true, tooltip: false },
    { title: "% of Portfolio", tag: false, tooltip: false },
  ],
  rows: [
    [
      { value: "Pershing", main: true, tooltip: false },
      { value: "$63,012,418" },
      { value: "$57,284,016" },
      { value: "39.47%" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
    ],
    [
      { value: "AX3000123", tooltip: false },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
      { value: "39.47%" },
    ],
    [
      { value: "NR4000XYZ", tooltip: false },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
      { value: "39.47%" },
    ],
    [
      {
        value: "JP Morgan",
        main: true,
        tooltip: false,
      },
      { value: "$63,012,418" },
      { value: "$57,284,016" },
      { value: "39.47%" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
    ],
    [
      { value: "JPM00L123", tooltip: false },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
      { value: "39.47%" },
    ],
    [
      {
        value: "Citibank",
        main: true,
        tooltip: false,
      },
      { value: "$63,012,418" },
      { value: "$57,284,016" },
      { value: "39.47%" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
    ],
    [
      { value: "CITI000123", tooltip: false },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
      { value: "39.47%" },
    ],
    [
      {
        value: "Directly Owned",
        main: true,
        tooltip: false,
      },
      { value: "$63,012,418" },
      { value: "$57,284,016" },
      { value: "39.47%" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
    ],
    [
      {
        value: "Greenspring Associates",
        tooltip: false,
      },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "-35.52%" },
      { value: "-37.85%" },
      { value: "-75.53%" },
      { value: "39.47%" },
    ],
    [
      { value: "Domun Investments", tooltip: false },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
      { value: "39.47%" },
    ],
    [
      { value: "Dji Properties", tooltip: false },
      { value: "$43,124,099" },
      { value: "$43,124,099" },
      { value: "35.52%" },
      { value: "37.85%" },
      { value: "75.53%" },
      { value: "39.47%" },
    ],
    [
      { value: "Totals", tooltip: false, iconLink: false },
      { value: "$96,196,377" },
      { value: "$87,451,252" },
      { value: "24.68%" },
      { value: "22.21%" },
      { value: "28.91%" },
      { value: "100%" },
    ],
  ],

  totals: true,
  headerTag: true,
};

export const dataTableAlternatives = {
  headers: [
    { title: "Asset Type", tag: false, tooltip: false },
    { title: "Allocation", tag: false, tooltip: true },
    { title: "Vintage or Funding Year", tag: false, tooltip: true },
    { title: "Paid-in-Capital", tag: false, tooltip: true },
    { title: "Unfunded", tag: false, tooltip: true },
    { title: "Distributions", tag: false, tooltip: true },
    { title: "Quantity", tag: false, tooltip: true },
    { title: "Market Value", tag: false, tooltip: true },
    { title: "IRR", tag: false, tooltip: true },
    { title: "MOIC", tag: false, tooltip: true },
    { title: "Custodian", tag: false, tooltip: false },
  ],
  rows: [
    [
      { value: "Private Equity", tooltip: false, main: true },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: ""}
    ],
    [
      { value: "Peg Digital Growth Fund Offshore Special II LP", tooltip: false },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: "JPMorgan"}
    ],
    [
      { value: "Private Real Estate", tooltip: false, main: true },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: ""}
    ],
    [
      { value: "Domun Real Estate Offshore Fund, LP", tooltip: false },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: "Directly Owner"}
    ],
    [
      {
        value: "Monte Rosa Opp.-R.E.D.II(2c)8.8",
        tooltip: false,
      },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: "Pictet"}
    ],
    [
      { value: "Progress Residential FREO", tooltip: false },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: "Goldman Sachs"}
    ],
    [
      { value: "Riverstone Investments Europe", tooltip: false, iconLink: false },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: "Goldman Sachs"}
    ],
    [
      { value: "Buyout and Secondaries", tooltip: false, main: true },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: ""}
    ],
    [
      { value: "B&B Investors Offshore, SLP", tooltip: false, iconLink: false },
      { value: "3.08%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: "Goldman Sachs"}
    ],
    [
      { value: "Total", tooltip: false, iconLink: false },
      { value: "100%" },
      { value: "" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "$0.00" },
      { value: "" },
      { value: "$381,676.50" },
      { value: "-19.04%%" },
      { value: "3.83" },
      { value: ""}
    ],
  ],

  totals: true,
  headerTag: false,
};

export const dataTableRecentOrders = {
  rows: [
    [
      { value: "Buy", type: "buy" },
      { value: "3/12/2021" },
      { value: "FutboTV,Inc (FUBO)", highlighted: true },
      { value: { first: "$251.08", second: "8 shares at 31.37" } },
    ],
    [
      { value: "Sell", type: "sell" },
      { value: "3/10/2021" },
      { value: "Jumia Technologies AG (JMIA)", highlighted: true },
      { value: { first: "$193.93", second: "5 shares at 38.79" } },
    ],
    [
      { value: "Buy", type: "buy" },
      { value: "3/9/2021" },
      { value: "Call GME @ 54 Exp Mar 12, 2021", highlighted: true },
      { value: { first: "$600.00", second: "1 contract at $6.10" } },
    ],
    [
      { value: "Sell", type: "sell" },
      { value: "3/4/2021" },
      { value: "Call GME @ 54 Exp Mar 12, 2021", highlighted: true },
      { value: { first: "$510.00", second: "1 contract at $5.10" } },
    ],
    [
      { value: "Sell", type: "sell" },
      { value: "3/4/2021" },
      { value: "SPDR SP&500 ETF (SPY)", highlighted: true },
      { value: { first: "$280.19", second: "100 shares at 2.80" } },
    ],
  ],
};

export const dataTableFicha = {
  headers: [
    { title: "Trade Date", tooltip: false },
    { title: "Account Name", tooltip: false },
    { title: "Type", tooltip: false },
    { title: "Security", tag: false },
    { title: "Units", tag: false },
    { title: "Value", tag: false },
    { title: "Summary", },
    { title: "Transaction ID", },
  ],
  rows: [
    [
      { value: "3/25/21" },
      { value: "Hudson_PE" },
      { value: "Contribution" },
      { value: "Domum Real Estate Offshore Fund, LP" },
      { value: "20,000.00" },
      { value: "($20,000.00)" },
      { value: "$20,000.00" },
      { value: "1063720769" },
    ],
    [
      { value: "12/11/20" },
      { value: "Hudson_PE" },
      { value: "Contribution" },
      { value: "Domum Real Estate Offshore Fund, LP" },
      { value: "230,000.00" },
      { value: "($230,000.00)" },
      { value: "$230,000.00" },
      { value: "1063720769" },
    ],
    [
      { value: "10/26/20" },
      { value: "Hudson_PE" },
      { value: "Contribution" },
      { value: "Domum Real Estate Offshore Fund, LP" },
      { value: "110,000.00" },
      { value: "($110,000.00)" },
      { value: "$110,000.00" },
      { value: "1063720769" },
    ],
    [
      { value: "10/26/20" },
      { value: "Hudson_PE" },
      { value: "Contribution" },
      { value: "Domum Real Estate Offshore Fund, LP" },
      { value: "0" },
      { value: "$1,000,000.00" },
      { value: "$1,000,000.00" },
      { value: "1063720769" },
    ],
  ],

  totals: false,
  headerTag: false,
};


export const dataChart1 = [
  {
    name: "PIMCO Gis U.S Short-Term Fund Institutional Class (USD)(offshore)",
    y: 2.34,
    //sliced: true,
    //selected: true,
  },
  {
    name: "Lord Abbett Ultra Short Bond Fund ClassZ (USD)(acc)",
    y: 2.25,
  },
  {
    name: "Apple Inc",
    y: 2.13,
  },
  {
    name:
      "iShares VII PLC - iShares Usd Treasury Bond 1-3YR Ucits ETF Usd (acc) B Accum",
    y: 1.98,
  },
  {
    name: "Amazon.Com Inc",
    y: 1.89,
  },
  {
    name: "Allianceber SHT Dur Hi YLD 12",
    y: 1.69,
  },
  {
    name: "PIMCO Gis-Income F-Invs Acc Held BY Euroclear",
    y: 1.41,
  },
  {
    name: "Alliancebern Amer Inc Port 12",
    y: 1.39,
  },
  {
    name: "Money Market Fund G34002F149",
    y: 1.32,
  },
  {
    name: "PIMCO Gis Income Fund Class E(acc)(USD)(offshore)",
    y: 1.22,
  },
];

export const dataChart2 = [
  {
    name: "Fixed Income",
    y: 57.89,
    //sliced: true,
    //selected: true,
  },
  {
    name: "Equity",
    y: 32.31,
  },
  {
    name: "Cash & Cash Equivalent",
    y: 2.47,
  },
  {
    name:
      "Commodities",
    y: 6.48,
  },
  {
    name: "Alternatives",
    y: 0.86,
  },
];

export const dataChart3 = [
  {
    name: "ETFs",
    y: 2.34,
    //sliced: true,
    //selected: true,
  },
  {
    name: "Stocks",
    y: 2.25,
  },
  {
    name: "Bonds",
    y: 2.13,
  },
  {
    name:
      "Money Market Funds",
    y: 1.98,
  },
  {
    name: "Cash",
    y: 1.89,
  },
  {
    name: "REITs",
    y: 1.69,
  },
  {
    name: "Private Equity",
    y: 1.41,
  },
  {
    name: "Options",
    y: 1.39,
  },
];

export const dataChartCustodian = [
  {
    name: "Pershing",
    y: 2.34,
    //sliced: true,
    //selected: true,
  },
  {
    name: "JP Morgan",
    y: 2.25,
  },
  {
    name: "Citibank",
    y: 2.13,
  },
  {
    name:
      "Directly Owned",
    y: 1.98,
  },
];

export const dataChartAlternatives = [
  {
    name: "PrivateEquity",
    y: 2.34,
    //sliced: true,
    //selected: true,
  },
  {
    name: "Private Real Estate",
    y: 2.25,
  },
  {
    name: "Buyout and Secondaries",
    y: 2.13,
  },
  {
    name:
      "Distressed",
    y: 1.98,
  },
  {
    name: "Tech Private Equity",
    y: 1.89,
  },
  {
    name: "Venture",
    y: 1.69,
  },
  {
    name: "Unknown",
    y: 1.41,
  },

];
